export type SurfaceRefReference = {
  id: string;
  title: string;
};

export type SurfaceRefGroup = SurfaceRefReference;

export type SurfaceRefReferenceLabel = SurfaceRefReference;

export type SurfaceRefGroupLabel = SurfaceRefReferenceLabel;

/**
 * Keep every real reference action. Model IDs identify actions, while labels are
 * derived solely from user-visible titles and menu order.
 */
export function buildSurfaceReferenceLabels(
  references: readonly SurfaceRefReference[]
): SurfaceRefReferenceLabel[] {
  const seenIds = new Set<string>();
  const uniqueReferences = references.filter(reference => {
    if (!reference.id || seenIds.has(reference.id)) return false;
    seenIds.add(reference.id);
    return true;
  });
  return uniqueReferences;
}

export const buildGroupReferenceLabels = buildSurfaceReferenceLabels;
